import React from 'react';
import Button from 'grommet/components/Button';
import OptimizeIcon from 'grommet/components/icons/base/Optimize';
import Box from 'grommet/components/Box';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Anchor from 'grommet/components/Anchor';
import TextInput from 'grommet/components/TextInput';
import Label from 'grommet/components/Label';
import FormField from 'grommet/components/FormField';
import Select from 'grommet/components/Select';
import TableSample from "./tablesample.js"

//let finalObject = {}
let length = 0;
class Anomaly extends React.Component {
    constructor(props) {
        super(props);
        //let realJsonParsed;
        try {
            this.state = { 
                finalObject: {},
                dataNames: {},
                typesTable: [],
                jsonoutput: [],
                resultReady: false,
                dataObjectParsed: props.dataObject ? props.dataObject : []
                 }
        }
        catch(error) {
            alert(`JSON input contains incosistencies, Please fix them and reload the data. ${error}`);
            this.state = { 
                finalObject: {},
                dataNames: {},
                dataObjectParsed: []
                 }
        }
        
        this._onSelect = this._onSelect.bind(this);
    }
    componentDidMount() {
        const {dataNames} = this.props;
        const {dataObjectParsed, typesTable} = this.state;
        let outputTypes = []
        outputTypes[0] = [];
        outputTypes[1] = [];
        outputTypes[2] = [];
        outputTypes[3] = [];
        outputTypes[4] = [];
        console.log(dataNames["positionname1"])
        console.log(dataNames["positiontype1"])

        let object = {};
            let mix = 0;
            
            for (let i = 0; i < length; i++) {
                let string = 0, number = 0, boolean = 0, empty = 0, nullValue = 0;
                
                dataObjectParsed[i].forEach((value, index)=>{
                    if (typeof value === "number" && value !== "") {
                        ++number;
                    } else if (typeof value === "string" && value !== "") {
                        ++string
                    } else if (value === "") {
                        ++empty
                    }else if (typeof value === "boolean" && value !== "") {
                        ++boolean
                    } else if (value === null) {
                        ++nullValue
                    }
                })

                object[`positionname${i + 1}`] = dataNames[`positionname${i + 1}`]

                if (number === dataObjectParsed[i].length) {
                    object[`positiontype${i + 1}`] = `Number`
                } else if (string === dataObjectParsed[i].length ) {
                    object[`positiontype${i + 1}`] = `String`
                } else if (boolean === dataObjectParsed[i].length) {
                    object[`positiontype${i + 1}`] = `Boolean`
                } else {
                    object[`positiontype${i + 1}`] = `Mix`;
                    ++mix
                }
                
                /* if (nullValue > 0 || empty > 0) {
                    alert(`${nullValue} null values and ${empty} empty values found. Please remove those to improve accuracy in the results`)
                } */

                //Booleans are not captured they are string TRUE and FALSE using google Sheets
                //const types = {number, string, boolean, empty}
                //outputTypes.push(types)
                outputTypes[0].push(dataNames[`positionname${i + 1}`])
                outputTypes[1].push(number);
                outputTypes[2].push(string);
                outputTypes[3].push(boolean);
                outputTypes[4].push(empty);

            }
            if (mix > 0) {
                alert("We found some incosistencies (Mix types). Scroll down and check table to resolve them. Keep arrays with single types (number, string or boolean)")
            }
            this.setState({finalObject: object, resultReady: true, typesTable: outputTypes})

        /* if (dataNames["positionname1"] && dataNames["positiontype1"]) {
            this.setState({finalObject: dataNames})
        } else if (dataNames["positionname1"]) {
            let object = {};
            let mix = 0;
            
            for (let i = 0; i < length; i++) {
                let string = 0, number = 0, boolean = 0, empty = 0, nullValue = 0;
                
                dataObjectParsed[i].forEach((value, index)=>{
                    if (typeof value === "number" && value !== "") {
                        ++number;
                    } else if (typeof value === "string" && value !== "") {
                        ++string
                    } else if (value === "") {
                        ++empty
                    }else if (typeof value === "boolean" && value !== "") {
                        ++boolean
                    } else if (value === null) {
                        ++nullValue
                    }
                })

                object[`positionname${i + 1}`] = dataNames[`positionname${i + 1}`]

                if (number === dataObjectParsed[i].length) {
                    object[`positiontype${i + 1}`] = `Number`
                } else if (string === dataObjectParsed[i].length ) {
                    object[`positiontype${i + 1}`] = `String`
                } else if (boolean === dataObjectParsed[i].length) {
                    object[`positiontype${i + 1}`] = `Boolean`
                } else {
                    object[`positiontype${i + 1}`] = `Mix`;
                    ++mix
                }
                
                

                //Booleans are not captured they are string TRUE and FALSE using google Sheets
                //const types = {number, string, boolean, empty}
                //outputTypes.push(types)
                outputTypes[0].push(dataNames[`positionname${i + 1}`])
                outputTypes[1].push(number);
                outputTypes[2].push(string);
                outputTypes[3].push(boolean);
                outputTypes[4].push(empty);

            }
            if (mix > 0) {
                alert("We found some incosistencies (Mix types). Scroll down and check table to resolve them. Keep arrays with single types (number, string or boolean)")
            }
            this.setState({finalObject: object, resultReady: true, typesTable: outputTypes})
        } else {
            let object = {};
            let mix = 0;
            let outputTypes = []
            outputTypes[0] = [];
            outputTypes[1] = [];
            outputTypes[2] = [];
            outputTypes[3] = [];
            outputTypes[4] = [];
            for (let i = 0; i < length; i++) {
                let string = 0, number = 0, boolean = 0, empty = 0, nullValue = 0;
                dataObjectParsed[i].forEach((value, index)=>{
                    if(typeof value === "number") {
                        ++number;
                    } else if(typeof value === "string" && value !== "") {
                        ++string
                    } else if(typeof value === "string" && value === "") {
                        ++empty
                    }else if(typeof value === "boolean") {
                        ++boolean
                    } else if(typeof value === "boolean") {
                        ++boolean
                    } else if (value === null) {
                        ++nullValue
                    }
                })

                object[`positionname${i + 1}`] = `name${i + 1}`

                if (number === dataObjectParsed[i].length) {
                    object[`positiontype${i + 1}`] = `Number`
                } else if (string === dataObjectParsed[i].length ) {
                    object[`positiontype${i + 1}`] = `String`
                } else if (boolean === dataObjectParsed[i].length) {
                    object[`positiontype${i + 1}`] = `Boolean`
                } else {
                    object[`positiontype${i + 1}`] = `Mix`;
                    ++mix
                }
                //if (nullValue > 0 || empty > 0) {
                //    alert(`${nullValue} null values and ${empty} empty values found. Please remove those to improve accuracy in the results`)
                //}
                //Booleans are not captured they are string TRUE and FALSE using google Sheets
                //const types = {number, string, boolean, empty}
                //outputTypes.push(types)
                
                outputTypes[0].push(dataNames[`positionname${i + 1}`])
                outputTypes[1].push(number);
                outputTypes[2].push(string);
                outputTypes[3].push(boolean);
                outputTypes[4].push(empty);
            }
            if (mix > 0) {
                alert("We found some incosistencies (Mix types). Scroll down and check table to resolve them. Keep arrays with single types (number, string or boolean)")
            }
            this.setState({finalObject: object, resultReady: true, typesTable: outputTypes})
        } */
    }
    _onClick(output, length) {
        //this.props.onSubmit()
        let anEmpty = false;
        Object.values(output).forEach((element, index)=>{
            if (element === "") {
                anEmpty = true;
            }
        })
        if (!anEmpty) {
            this.props.onSubmit(output, length)
        } else {
            alert("Variable name or type cannot be Empty. Use at least default")
        }
    }
    _onSelect(event) {
        this.setState({steps: event})
    }
    _onChange(field, event) {
        let finalObjectNew = this.state.finalObject
        finalObjectNew[field] = event.target.value
        this.setState({finalObject: finalObjectNew})
        //check form from form recipes how to save
    }
    _onChangeSelect(field, position, event) {
        const {dataObjectParsed} = this.state;
        let anError = false;
        let whereError = []
        dataObjectParsed[position - 1].forEach((value, index)=>{
            if(event.value === "Number" && typeof value !== "number") {
                whereError.push(index + 1);
                anError = true;
            } else if(event.value === "String" && typeof value !== "string") {
                whereError.push(index + 1);
                anError = true;
            } else if(event.value === "Boolean" && typeof value !== "boolean") {
                whereError.push(index + 1);
                anError = true;
            }
        })
        if (!anError) {
            let finalObjectNew = this.state.finalObject
            finalObjectNew[field] = event.value
            this.setState({finalObject: finalObjectNew})
            //check form from form recipes how to save
        } else {
            alert(`Please review column ${position} and row(s) ${whereError}. It is not type ${event.value}`)
        }
    }
    render() {
        const {dataNames, dataObjectParsed, resultReady, typesTable} = this.state;

        const {finalObject} = this.state;

        console.log(typesTable);
        //No other option that parsing the object just to know the length.  Too expensive. Wish I could only get the length from data source
        //But there is string all the time. Another option.. count number of [ in the array, then I know how many... not bad idea
        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        length = dataObjectParsed.length

        let content = (
                <div>
                <Box direction='row'
                        justify='center'
                        align='center'
                        wrap={true}
                        reverse={false}
                        margin='none'>
                        {dataObjectParsed.map((input, index)=>{
                            const selectValue = `positiontype${index + 1}`
                            return (
                                <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'>
                                    
                                    <Label>
                                    {`Position ${index + 1}`}
                                    </Label>
                                    <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'>
                                      <TextInput 
                                      placeHolder={"Name"}
                                      onDOMChange={this._onChange.bind(this, `positionname${index + 1}`)} 
                                      value={finalObject[`positionname${index + 1}`]}/>  
                                    </Box>
                                    <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'>
                                        <Select placeHolder='None'
                                            options={[[finalObject[selectValue]]]}
                                            placeHolder={"Type"}
                                            value={finalObject[selectValue]}
                                            onChange={this._onChangeSelect.bind(this, `positiontype${index + 1}`, index + 1)} />
                                    </Box>
                                </Box>
                            )
                        })}
                        
                </Box>
                
                </div>
            )
        return (
            <div>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h2><strong>Variable Names and Types</strong></h2>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        <Button label='Validate Outliers'
                            type='submit'
                            primary={true}
                            onClick={this._onClick.bind(this, finalObject, length)} 
                        />
                    </Box>
                </div>
                <hr style={{width: "100%"}} />
                <div>Check table below with count of types. Ideally they need to be only one type and not mixed. Remove empty values</div>
                {content}
                {resultReady && <div><TableSample iterator={typesTable} dataNames={["Variable","number", "string", "boolean", "empty"]}/></div>}
            </div>  
        );
    }
}

export default Anomaly;

/* 


//POTENTIALLUY RUN CAN HAVE SOME DESCRIPTIVE STATISTICS BASIC. LIKE CLEANING DATA, NULLS, WARNINGS ETC, SO USERS CLEAN UP BEFORE DOIND CALCS
import React from 'react';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import TableHeader from 'grommet/components/TableHeader';


import Value from 'grommet/components/Value';
import Box from 'grommet/components/Box';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Tiles from 'grommet/components/Tiles';
import NumberInput from 'grommet/components/NumberInput';
import Tile from 'grommet/components/Tile';
import Label from 'grommet/components/Label';
import Anchor from 'grommet/components/Anchor';

const names = ["10 Attempts", "20 Attempts", "30 Attempts"]

const colorPrim = ["rgb(91,100,114)", "rgb(196,175,84)", "rgb(86,130,216)"];

class BubbleSample extends React.Component {
    constructor() {
        super();
        this.state = { 
            title: true,
            legends: true,
            exprt: false,
            min: null,
            max: null,
            range: null,
            mean: null,
            variance: null,
            time: null,
            showcomponent: false,
            finalResult: null
             }
        this._onresult = this._onresult.bind(this)
        this._set2digits = this._set2digits.bind(this)
    }
    componentDidMount() {
        this.setState({showcomponent: true})
    }
    _onClick() {
        //this.props.onSubmit()
        this.props.onSubmit()
    }
    _onresult(event) {
        const {range, mean, min, variance, max} = event.detail.finalResult;
        const {finalResult, time} = event.detail;
        this.setState({range, mean, min, variance, max, time, finalResult})
    }
    _set2digits(value) {
        if (value) {
            return value.toFixed(2)
        } else {
            return null
        }
    }
    _onSelect() {

    }
    _onSort() {

    }
    
    render() {
        const {dataNames, length, rows} = this.props;
        //Here again, No other option that parsing the object just to know the length. I could have gotten from the firs time it got parsed.
        //If I parse, I will pass huge object around (See performance), but redefining input data (manual) requires parse back to string then again object.
        //But there is string all the time. Another option.. count number of [ in the array, then I know how many... not bad idea
        const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        
        return (
            <div>
                <h2><strong>Summary</strong></h2>
                <Table scrollable={true}
                selectable={true}
                onSelect={this._onSelect.bind(this)}>
                    <TableHeader labels={['Name', 'Type']} />
                    <tbody>
                        {dataObjectParsed.map((input, index)=> {
                            return (
                            <TableRow>
                                <td>
                                {dataNames[`positionname${index+1}`]}
                                </td>
                                <td>
                                {dataNames[`positiontype${index+1}`]}
                                </td>
                            </TableRow>
                            )
                        })}
                    </tbody>
                </Table>
                <Button label='Looks Good!'
            type='submit'
            primary={true}
            onClick={this._onClick.bind(this)} />
            </div>
        );
    }
}

//<LinealRegression xs={this.props.dataObject[0]} ys={this.props.dataObject[1]} x={x} result={this._onresult} predict={this._onpredict}/>
export default BubbleSample;
 */


// WEBPACK FOOTER //
// ./src/samples/data/datarun.js